"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientError = void 0;
const class_validator_1 = require("class-validator");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
class ClientError extends mocks_1.Model {
}
exports.ClientError = ClientError;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], ClientError.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], ClientError.prototype, "stack", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], ClientError.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], ClientError.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], ClientError.prototype, "userAgent", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, property_1.Property)({ required: false, allowMixed: 0 }),
    __metadata("design:type", Object)
], ClientError.prototype, "metadata", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, property_1.Property)({ type: [Object], required: false, allowMixed: 0 }),
    __metadata("design:type", Array)
], ClientError.prototype, "replayData", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(constants_1.ClientErrorLevelEnum),
    (0, property_1.Property)({ type: String, enum: constants_1.ClientErrorLevelEnum }),
    __metadata("design:type", String)
], ClientError.prototype, "level", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, property_1.Property)(),
    __metadata("design:type", Boolean)
], ClientError.prototype, "acknowledged", void 0);
